import React from "react";
import "./ArticlePreviewTopTitle.css";
import {
  setPreviewingTextLineIDs,
  setPreviewingItemHidingMode
} from "../../redux/actions/editArticlePanel";
import { connect } from "react-redux";
import { combineTextLineIDs } from "../../model/privateACDType";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";

class ArticlePreviewTopTitle extends React.Component {
  constructor(props) {
    super(props);
    this.onHover = this.onHover.bind(this);
    this.onInvisibleClicked = this.onInvisibleClicked.bind(this);
    this.onHighlightClicked = this.onHighlightClicked.bind(this);
  }

  onHover(hovering) {
    const { article, metaDict, setPreviewingTextLineIDs } = this.props;

    const articleID = article.id;

    const titleID = articleID + "-TITLE";
    const subtitleID = articleID + "-SUBTITLE";

    const titleItem = metaDict[titleID];
    const subtitleItem = metaDict[subtitleID];

    if (hovering) {
      const reducer = (accumulator, currentValue) =>
        combineTextLineIDs(accumulator, currentValue.textLineIDs);
      const allTextLineIDs = [titleItem, subtitleItem].reduce(reducer, null);

      setPreviewingTextLineIDs({ textLineIDs: allTextLineIDs });
    } else {
      setPreviewingTextLineIDs({ textLineIDs: null });
    }
  }

  onInvisibleClicked() {
    const { mode, article, setPreviewingItemHidingMode } = this.props;
    const articleID = article.id;

    const titleID = articleID + "-TITLE";
    const subtitleID = articleID + "-SUBTITLE";

    if (mode === "invisible") {
      setPreviewingItemHidingMode({ id: titleID, mode: null });
      setPreviewingItemHidingMode({ id: subtitleID, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: titleID, mode: "invisible" });
      setPreviewingItemHidingMode({ id: subtitleID, mode: "invisible" });
    }
  }

  onHighlightClicked() {
    const { mode, article, setPreviewingItemHidingMode } = this.props;
    const articleID = article.id;

    const titleID = articleID + "-TITLE";
    const subtitleID = articleID + "-SUBTITLE";

    if (mode === "highlight") {
      setPreviewingItemHidingMode({ id: titleID, mode: null });
      setPreviewingItemHidingMode({ id: subtitleID, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: titleID, mode: "highlight" });
      setPreviewingItemHidingMode({ id: subtitleID, mode: "highlight" });
    }
  }

  render() {
    const { article, issue, metaDict, mode } = this.props;
    const articleID = article.id;

    const titleID = articleID + "-TITLE";
    const subtitleID = articleID + "-SUBTITLE";
    const mainImgID = articleID + "-MAIN_IMG";

    const titleItem = metaDict[titleID];
    const subtitleItem = metaDict[subtitleID];
    const mainImgItem = metaDict[mainImgID];

    const mainImgUri =
      mainImgItem == null ||
      mainImgItem.image == null ||
      mainImgItem.image.id == null
        ? ""
        : `${process.env.REACT_APP_API_ROOT}artworks/${
            mainImgItem.image.id
          }/static`;

    return (
      <div style={{ position: "relative", paddingBottom: "10pt" }}>
        <div
          onMouseEnter={() => this.onHover(true)}
          onMouseLeave={() => this.onHover(false)}
        >
          <div className="preview_main_img_banner_container">
            {mainImgUri && (
              <img
                alt="article main cover"
                className="preview_main_img"
                src={mainImgUri}
              />
            )}
            <div className="preview_main_img_overlay" />
            <div className="preview_meta_container">
              <div className="preview_meta_text">
                {issue.title.name} | {issue.issue}
              </div>
            </div>
            <div className="preview_title_area">
              {titleItem != null &&
                titleItem.text != null &&
                titleItem.text !== "" && (
                  <div className="preview_title">{titleItem.text}</div>
                )}
              {subtitleItem != null &&
                subtitleItem.text != null &&
                subtitleItem.text !== "" && (
                  <div className="preview_subtitle">{subtitleItem.text}</div>
                )}
            </div>
          </div>
        </div>
        <ButtonGroup
          style={{ position: "absolute", top: 0, right: "-70px" }}
          size="sm"
        >
          <Button
            variant={mode === "invisible" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onInvisibleClicked}
          >
            <span className="fa fa-eye-slash" />
          </Button>
          <Button
            variant={mode === "highlight" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onHighlightClicked}
          >
            <span className="fa fa-language" />
          </Button>
        </ButtonGroup>
      </div>
    );
  }
}

const mapDispatch = {
  setPreviewingTextLineIDs,
  setPreviewingItemHidingMode
};

const mapState = (state, ownProps) => {
  const { editArticlePanel } = state;
  const { previewHidingItemIDs } = editArticlePanel;

  const articleID = ownProps.article.id;
  const titleID = articleID + "-TITLE";

  return {
    mode: previewHidingItemIDs[titleID]
  };
};

export default connect(
  mapState,
  mapDispatch
)(ArticlePreviewTopTitle);
